var DataStore = require('../store');
var store = DataStore.default



const postDataRemove = async (data, route) => {
    fetch(store.state.url.office_sk_konsepSurat + route, {
        method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(data)
        })
        .then(res => res.json())
        .then(res_data => {
            return new Promise((resolve)=>{
                console.log(res_data)
                resolve(res_data)
            })
        });
}


const postData = async (data, route) => {
    return new Promise((resolve, reject) => {
        fetch(store.state.url.office_sk_konsepSurat + route, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(data)
        })
            .then(res_data => {
                resolve(res_data)
            });
    })
}





module.exports = {
    postData : postData,
    postDataRemove: postDataRemove,

}